<script setup lang="ts">
import type { WidgetBody, SliderItem } from '@/types/appTypes'

const app = useNuxtApp()
const storeArticleList = useStoreArticleList()
const storeArticleSlider = useStoreArticleSlider()

const refData = reactive({
  sideTopPc: {
    data: null as WidgetBody | null,
    loading: false,
  },
  sideTopRight: {
    data: null as WidgetBody | null,
    loading: false,
  },
  sideTopSp: {
    data: null as WidgetBody | null,
    loading: false,
  },
  sideReport: {
    items: [] as Article[],
    loading: false,
  },
  sideNews: {
    items: [] as Article[],
    loading: false,
  },
  sidePresent: {
    items: [] as Article[],
    loading: false,
  },
  sideGakugeiin: {
    items: [] as Article[],
    loading: false,
  },
  sideEvent: {
    items: [] as Article[],
    loading: false,
  },
  sideSpecial: {
    items: [] as Article[],
    loading: false,
  },
  sideRecommend: {
    items: [] as SliderItem[],
    loading: false,
  },
  sideBottom: {
    data: null as WidgetBody | null,
    loading: false,
  },
})

const isDisplayAd = computed((): boolean => {
  return true
  // const s = route.name
  // if (
  //   s === 'museum-slug'
  //   || s === 'event-slug'
  //   || s === 'jyunkai-slug'
  //   || s === 'report-slug'
  //   || s === 'special-slug'
  //   || s === 'news-slug'
  //   || s === 'static-slug'
  // ) {
  //   const item = storeArticleDetail.item
  //   if (item && item.is_adult === 1) {
  //     console.log('isDisplayAd(side)', false)
  //     return false
  //   }
  // }
  // return true
})

onMounted(async () => {
  const bannerTop = app.$device.isMobile ? 'side_top_sp' : 'side_top_pc'

  // ファーストビューに近いリストをfetch
  const [resTopPc, resReport, resNews] = await Promise.all([
    storeArticleList.fetchWidgetBody(bannerTop),
    storeArticleList.fetchList('reportSide'),
    storeArticleList.fetchList('newsSide'),
  ])
  console.log('TheSide onMounted', resTopPc, resReport, resNews)

  if (resTopPc?.data) {
    refData.sideTopPc.data = resTopPc.data
  }
  if (resReport?.data) {
    refData.sideReport.items = resReport.data.articles as Article[]
  }
  if (resNews?.data) {
    refData.sideNews.items = resNews.data.articles as Article[]
  }

  // 残りのサイドをfetch
  const [resPresent, resGakugeiin, resEvent, resSpecial, resSideRecommend, resSideBottom, resSideTopRight] = await Promise.all([
    storeArticleList.fetchList('presentSide'),
    storeArticleList.fetchList('gakugeiinSide'),
    storeArticleList.fetchList('eventSide', { query: { dateAfter: useDayjs().format('YYYY/MM/DD 00:00:00') } }),
    storeArticleList.fetchList('specialSide'),
    storeArticleSlider.fetchSlider('side_recommend'),
    storeArticleList.fetchWidgetBody('side_bottom'),
    storeArticleList.fetchWidgetBody('side_top_right'),
  ])
  console.log('TheSide onMounted', resTopPc, resReport, resEvent, resSpecial, resSideRecommend, resSideBottom, resSideTopRight)

  if (resPresent?.data) {
    refData.sidePresent.items = resPresent.data.articles as Article[]
  }
  if (resGakugeiin?.data) {
    refData.sideGakugeiin.items = resGakugeiin.data.articles as Article[]
  }
  if (resEvent?.data) {
    refData.sideEvent.items = resEvent.data.articles as Article[]
  }
  if (resSpecial?.data) {
    refData.sideSpecial.items = resSpecial.data.articles as Article[]
  }
  if (resSideRecommend?.data) {
    const sliderArticle = resSideRecommend.data.article as Article
    const sliderObjects = resSideRecommend.data.article_objects as ArticleObject[]
    refData.sideRecommend.items = storeArticleSlider.makeSliderItems(sliderArticle, sliderObjects)
  }
  if (resSideBottom?.data) {
    refData.sideBottom.data = resSideBottom.data
  }
  if (resSideTopRight?.data) {
    refData.sideTopRight.data = resSideTopRight.data
  }
})
</script>

<template>
  <div class="p-side">
    <template
      v-if="isDisplayAd"
    >
      <div
        v-if="app.$device.isMobile"
        class="c-sideItems"
      >
        <SideBannerArea
          v-bind:data="refData.sideTopSp.data"
        />
      </div>
      <div
        v-else
        class="c-sideItems"
      >
        <SideBannerArea
          v-bind:data="refData.sideTopPc.data"
        />
      </div>
      <!--
      <div
        class="c-advertise"
      >
        <adsbygoogle
          ad-slot="7741488425"
          ad-format="auto"
        ></adsbygoogle>
      </div>
      -->
    </template>

    <template
      v-if="isDisplayAd"
    >
      <div class="c-sideItems">
        <SideBannerArea
          v-bind:data="refData.sideTopRight.data"
        />
      </div>
    </template>

    <template
      v-if="isDisplayAd"
    >
      <div class="c-sideItems">
        <TheGptBottomAd />
      </div>
    </template>

    <div class="c-sideItems">
      <SideBox
        header="おすすめレポート"
        v-bind:link-to="{ path: '/report', query: { sort: 'open_date' } }"
      >
        <SideList
          class="sideReport"
          v-bind:items="refData.sideReport.items || []"
          v-bind:loading="refData.sideReport.loading"
        >
          <template
            v-slot:default="prop"
          >
            <ReportSideItem
              v-bind:item="prop.item"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="ニュース"
        link-to="/news"
      >
        <SideList
          class="sideNews"
          v-bind:items="refData.sideNews.items || []"
          v-bind:loading="refData.sideNews.loading"
        >
          <template
            v-slot:default="prop"
          >
            <v-divider />
            <NewsSideItem
              v-bind:item="prop.item"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="ご招待券プレゼント"
        link-to="/present"
      >
        <SideList
          class="sidePresent"
          v-bind:items="refData.sidePresent.items || []"
          v-bind:loading="refData.sidePresent.loading"
        >
          <template
            v-slot:default="prop"
          >
            <v-divider />
            <PresentSideItem
              v-bind:item="prop.item"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="学芸員募集"
        link-to="/gakugeiin"
      >
        <SideList
          class="sideGakugeiin"
          v-bind:items="refData.sideGakugeiin.items || []"
          v-bind:loading="refData.sideGakugeiin.loading"
        >
          <template
            v-slot:default="prop"
          >
            <v-divider />
            <GakugeiinSideItem
              v-bind:item="prop.item"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="展覧会ランキング"
        v-bind:link-to="{ path: '/event', query: { sort: 'pv_last_week' } }"
      >
        <SideList
          class="sideEvent"
          v-bind:items="refData.sideEvent.items || []"
          v-bind:loading="refData.sideEvent.loading"
        >
          <template
            v-slot:default="prop"
          >
            <v-divider />
            <EventSideItem
              v-bind:item="prop.item"
              v-bind:rank="prop.rank"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="特集"
        link-to="/special"
      >
        <SideList
          class="sideSpecial"
          v-bind:items="refData.sideSpecial.items || []"
          v-bind:loading="refData.sideSpecial.loading"
        >
          <template
            v-slot:default="prop"
          >
            <v-divider />
            <SpecialSideItem
              v-bind:item="prop.item"
            />
          </template>
        </SideList>
      </SideBox>
    </div>

    <div class="c-sideItems">
      <SideBox
        header="おすすめコンテンツ"
      >
        <SideLinkList
          v-bind:items="refData.sideRecommend.items || []"
          v-bind:loading="refData.sideRecommend.loading"
        />
      </SideBox>
    </div>

    <template
      v-if="isDisplayAd"
    >
      <div class="c-sideItems">
        <SideBannerArea
          v-bind:data="refData.sideBottom.data"
        />
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-sideItems {
  margin-top: 24px;

  &:first-child {
    margin-top: 0;
  }

  @include responsive.mq_down(sp) {
    margin-top: 30px;
  }
}
</style>
